"use client";

import { Turnstile as NextTurnstile } from "next-turnstile";

interface TurnstileProps {
  onVerify: (token: string | null) => void;
  siteKey: string;
}

export default function Turnstile({ onVerify, siteKey }: TurnstileProps) {
  return (
    <NextTurnstile
      siteKey={siteKey}
      onVerify={(token) => onVerify(token)}
      onExpire={() => onVerify(null)}
      onError={() => onVerify(null)}
    />
  );
}
